import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ["input", "verificationField"];

  connect() {
    if (this.hasInputTarget) {
      this.inputTargets[0].focus();
    }
  }

  paste(event) {
    event.preventDefault();
    const clipboardData = event.clipboardData || window.clipboardData;
    const pastedData = clipboardData.getData('Text');
    const pastedChars = pastedData.split("");

    this.inputTargets.forEach((input, index) => {
      if (pastedChars[index]) {
        input.value = pastedChars[index];

        if (index == this.inputTargets.length - 1) {
          input.form.requestSubmit();
        }
      }
    });
  }

  nextInput(event) {
    const input = event.target;
    this.updateVerificationField();

    if (input.value.length >= input.maxLength) {
      const index = this.inputTargets.indexOf(input);

      if (index < this.inputTargets.length - 1) {
        this.inputTargets[index + 1].focus();
      } else {
        input.form.requestSubmit();
      }
    }
  }

  previousInput(event) {
    const input = event.target;

    if (input.value.length === 0) {
      const index = this.inputTargets.indexOf(input);

      if (index > 0) {
        this.inputTargets[index - 1].focus();
      }
    }
  }

  updateVerificationField() {
    const value = this.inputTargets.map(input => input.value).join("");
    this.verificationFieldTarget.value = value;
  }
}